import { render, staticRenderFns } from "./yujianfenzhenItem.vue?vue&type=template&id=6fc953e8&scoped=true&"
import script from "./yujianfenzhenItem.vue?vue&type=script&lang=js&"
export * from "./yujianfenzhenItem.vue?vue&type=script&lang=js&"
import style0 from "./yujianfenzhenItem.vue?vue&type=style&index=0&id=6fc953e8&rel=stylesheet%2Fless&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc953e8",
  null
  
)

export default component.exports